const announcementText =
  "✨ CURATED AESTHETICS ✨  •  USE CODE 'HERVIBE25' FOR 25% OFF KAFTANS  •  NO FAKE SALES, PRICES ALREADY DOWN TO EARTH (AVG ₹699) 🌍  •  "

function renderAnnouncementItems(groupId) {
  return Array.from({ length: 4 }, (_, index) => (
    <div
      className="flex shrink-0 items-center pr-12"
      aria-hidden="true"
      key={`${groupId}-${index}`}
    >
      <span className="whitespace-pre text-[11px] font-bold uppercase tracking-[0.18em] leading-none sm:text-xs">
        {announcementText}
      </span>
    </div>
  ))
}

function AnnouncementBar() {
  return (
    <div className="w-full max-w-[100vw] overflow-hidden border-b border-white/10 bg-black text-white">
      <div className="w-full overflow-hidden py-2">
        <div
          className="announcement-marquee-track flex w-max items-center"
          style={{ animation: 'announcement-marquee 48s linear infinite' }}
        >
          {renderAnnouncementItems('first')}
          {renderAnnouncementItems('second')}
        </div>
        <span className="sr-only">{announcementText}</span>
      </div>
    </div>
  )
}

export default AnnouncementBar
